import { Theme } from "@material-ui/core";
import { EventType } from "../../../../common/data/service-proxies";

export const getColor = (
  record: any,
  source: string | undefined,
  theme: Theme
) => {
  if (!record || !source) {
    return "auto";
  }

  if (!record[source]) {
    return "auto";
  }

  if (record.eventType === EventType.Custom) {
    return theme.palette.type === "dark"
      ? theme.palette.primary.light
      : theme.palette.primary.dark;
  }

  switch (record[source]) {
    case "OFF":
    case "ChangeToOffDutyStatus":
    case "ChangeToOffDutyStatus-E":
    case "ChangeToOffDutyStatus-CR":
      return theme.palette.common.white;
    case "ON":
    case "ChangeToOnDutyNotDrivingStatus":
    case "ChangeToOnDutyNotDrivingStatus-E":
    case "ChangeToOnDutyNotDrivingStatus-CR":
      return theme.palette.info.contrastText;
    case "D":
    case "ChangeToDrivingStatus":
    case "ChangeToDrivingStatus-E":
    case "ChangeToDrivingStatus-CR":
      return theme.palette.success.contrastText;
    case "SB":
    case "ChangeToSleeperBerthStatus":
    case "ChangeToSleeperBerthStatus-E":
    case "ChangeToSleeperBerthStatus-CR":
      return theme.palette.warning.contrastText;
    default:
      return "auto";
  }
};

export const getBackgroundColor = (
  record: any,
  source: string | undefined,
  theme: Theme
) => {
  if (!record || !source) {
    return "auto";
  }

  if (!record[source]) {
    return "auto";
  }

  if (record.eventType === EventType.Custom) {
    return theme.palette.type === "dark"
      ? theme.palette.grey[700]
      : theme.palette.grey[300];
  }

  switch (record[source]) {
    case "OFF":
    case "ChangeToOffDutyStatus":
    case "ChangeToOffDutyStatus-E":
    case "ChangeToOffDutyStatus-CR":
      return theme.palette.grey[900];
    case "ON":
    case "ChangeToOnDutyNotDrivingStatus":
    case "ChangeToOnDutyNotDrivingStatus-E":
    case "ChangeToOnDutyNotDrivingStatus-CR":
      return theme.palette.info.main;
    case "D":
    case "ChangeToDrivingStatus":
    case "ChangeToDrivingStatus-E":
    case "ChangeToDrivingStatus-CR":
      return theme.palette.success.main;
    case "SB":
    case "ChangeToSleeperBerthStatus":
    case "ChangeToSleeperBerthStatus-E":
    case "ChangeToSleeperBerthStatus-CR":
      return theme.palette.warning.main;
    default:
      return "auto";
  }
};
